import(/* webpackMode: "eager", webpackExports: ["CountUp"] */ "/app/components/count-up.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeroReveal"] */ "/app/components/hero-reveal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HomeMagicBento"] */ "/app/components/home-magic-bento.tsx");
;
import(/* webpackMode: "eager" */ "/app/components/reveal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SiteHeader"] */ "/app/components/site-header.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
